const mutations = {
  SET_SETTINGS: 'SET_SETTINGS',
  SET_OPERATIONS: 'SET_OPERATIONS'
}

export { mutations }
